import _defineProperty from "/opt/build/repo/app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/opt/build/repo/app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _objectWithoutProperties from "/opt/build/repo/app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["startColor", "endColor", "isLoaded", "fadeDuration", "speed", "className"],
    _excluded2 = ["noOfLines", "spacing", "skeletonHeight", "className", "startColor", "endColor", "isLoaded", "fadeDuration", "speed", "children"],
    _excluded3 = ["size"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

// ../../../react-shim.js
import React from "react"; // src/skeleton.tsx

import { usePrevious } from "@chakra-ui/react-use-previous"; // ../../utilities/shared-utils/src/index.ts

var cx = function cx() {
  for (var _len = arguments.length, classNames = new Array(_len), _key = 0; _key < _len; _key++) {
    classNames[_key] = arguments[_key];
  }

  return classNames.filter(Boolean).join(" ");
}; // src/skeleton.tsx


import { chakra, cssVar, forwardRef, keyframes, omitThemingProps, useStyleConfig, useToken } from "@chakra-ui/system"; // src/use-is-first-render.ts

import { useEffect, useRef } from "react";

function useIsFirstRender() {
  var isFirstRender = useRef(true);
  useEffect(function () {
    isFirstRender.current = false;
  }, []);
  return isFirstRender.current;
} // src/skeleton.tsx


var StyledSkeleton = chakra("div", {
  baseStyle: {
    boxShadow: "none",
    backgroundClip: "padding-box",
    cursor: "default",
    color: "transparent",
    pointerEvents: "none",
    userSelect: "none",
    "&::before, &::after, *": {
      visibility: "hidden"
    }
  }
});
var $startColor = cssVar("skeleton-start-color");
var $endColor = cssVar("skeleton-end-color");
var fade = keyframes({
  from: {
    opacity: 0
  },
  to: {
    opacity: 1
  }
});
var bgFade = keyframes({
  from: {
    borderColor: $startColor.reference,
    background: $startColor.reference
  },
  to: {
    borderColor: $endColor.reference,
    background: $endColor.reference
  }
});
var Skeleton = forwardRef(function (props, ref) {
  var styles = useStyleConfig("Skeleton", props);
  var isFirstRender = useIsFirstRender();

  var _omitThemingProps = omitThemingProps(props),
      _omitThemingProps$sta = _omitThemingProps.startColor,
      startColor = _omitThemingProps$sta === void 0 ? "" : _omitThemingProps$sta,
      _omitThemingProps$end = _omitThemingProps.endColor,
      endColor = _omitThemingProps$end === void 0 ? "" : _omitThemingProps$end,
      isLoaded = _omitThemingProps.isLoaded,
      fadeDuration = _omitThemingProps.fadeDuration,
      speed = _omitThemingProps.speed,
      className = _omitThemingProps.className,
      rest = _objectWithoutProperties(_omitThemingProps, _excluded);

  var _useToken = useToken("colors", [startColor, endColor]),
      _useToken2 = _slicedToArray(_useToken, 2),
      startColorVar = _useToken2[0],
      endColorVar = _useToken2[1];

  var wasPreviouslyLoaded = usePrevious(isLoaded);

  var _className = cx("chakra-skeleton", className);

  var cssVarStyles = _objectSpread(_objectSpread({}, startColorVar && _defineProperty({}, $startColor.variable, startColorVar)), endColorVar && _defineProperty({}, $endColor.variable, endColorVar));

  if (isLoaded) {
    var animation = isFirstRender || wasPreviouslyLoaded ? "none" : "".concat(fade, " ").concat(fadeDuration, "s");
    return /* @__PURE__ */React.createElement(chakra.div, _objectSpread({
      ref: ref,
      className: _className,
      __css: {
        animation: animation
      }
    }, rest));
  }

  return /* @__PURE__ */React.createElement(StyledSkeleton, _objectSpread(_objectSpread({
    ref: ref,
    className: _className
  }, rest), {}, {
    __css: _objectSpread(_objectSpread(_objectSpread({}, styles), cssVarStyles), {}, {
      _dark: _objectSpread({}, cssVarStyles),
      animation: "".concat(speed, "s linear infinite alternate ").concat(bgFade)
    })
  }));
});
Skeleton.defaultProps = {
  fadeDuration: 0.4,
  speed: 0.8
};
Skeleton.displayName = "Skeleton"; // src/skeleton-text.tsx

import { useBreakpointValue } from "@chakra-ui/media-query";
import { chakra as chakra2 } from "@chakra-ui/system";

function range(count) {
  return Array(count).fill(1).map(function (_, index) {
    return index + 1;
  });
}

var defaultNoOfLines = 3;

var SkeletonText = function SkeletonText(props) {
  var _props$noOfLines = props.noOfLines,
      noOfLines = _props$noOfLines === void 0 ? defaultNoOfLines : _props$noOfLines,
      _props$spacing = props.spacing,
      spacing = _props$spacing === void 0 ? "0.5rem" : _props$spacing,
      _props$skeletonHeight = props.skeletonHeight,
      skeletonHeight = _props$skeletonHeight === void 0 ? "0.5rem" : _props$skeletonHeight,
      className = props.className,
      startColor = props.startColor,
      endColor = props.endColor,
      isLoaded = props.isLoaded,
      fadeDuration = props.fadeDuration,
      speed = props.speed,
      children = props.children,
      rest = _objectWithoutProperties(props, _excluded2);

  var noOfLinesValue = useBreakpointValue(typeof noOfLines === "number" ? [noOfLines] : noOfLines) || defaultNoOfLines;
  var numbers = range(noOfLinesValue);

  var getWidth = function getWidth(index) {
    if (noOfLinesValue > 1) {
      return index === numbers.length ? "80%" : "100%";
    }

    return "100%";
  };

  var _className = cx("chakra-skeleton__group", className);

  return /* @__PURE__ */React.createElement(chakra2.div, _objectSpread({
    className: _className
  }, rest), numbers.map(function (number, index) {
    if (isLoaded && index > 0) {
      return null;
    }

    var sizeProps = isLoaded ? null : {
      mb: number === numbers.length ? "0" : spacing,
      width: getWidth(number),
      height: skeletonHeight
    };
    return /* @__PURE__ */React.createElement(Skeleton, _objectSpread({
      key: numbers.length.toString() + number,
      startColor: startColor,
      endColor: endColor,
      isLoaded: isLoaded,
      fadeDuration: fadeDuration,
      speed: speed
    }, sizeProps), index === 0 ? children : void 0);
  }));
};

SkeletonText.displayName = "SkeletonText"; // src/skeleton-circle.tsx

var SkeletonCircle = function SkeletonCircle(_ref3) {
  var _ref3$size = _ref3.size,
      size = _ref3$size === void 0 ? "2rem" : _ref3$size,
      rest = _objectWithoutProperties(_ref3, _excluded3);

  return /* @__PURE__ */React.createElement(Skeleton, _objectSpread({
    borderRadius: "full",
    boxSize: size
  }, rest));
};

SkeletonCircle.displayName = "SkeletonCircle";
export { Skeleton, SkeletonCircle, SkeletonText };